import { useEffect, useState } from "react";
import ReactDOM from "react-dom";



export default function Modal({ isOpen, onClose, children }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return ReactDOM.createPortal(
    isOpen && (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center">
        {/* Overlay */}
        <div
          className="fixed inset-0 bg-black/50"
          onClick={onClose}
        ></div>

        {/* Content */}
        <div className="relative bg-white rounded-lg shadow-lg z-50 w-auto mx-4 p-6">
          {children}
        </div>
      </div>
    ),
    document.body
  );
}
